module.exports = __webpack_public_path__ + "img/chipin-plus-text.d95bebed.svg";